import {Grid} from '@yandex-delivery/blocks'

import {Skeleton} from 'src/shared/components/desktop'

import {BusinessBannerModal} from '../../BusinessBannerModal/BusinessBannerModal'
import {VerticalPlate} from '../VerticalPlate/VerticalPlate'
import * as classes from './DeliveryDirectionVerticals.classes'
import {useDeliveryDirectionVerticals} from './hooks'
import {translations} from './i18n'

const skeleton = (
  <Grid size="s" container>
    {Array.from({length: 4}, (_, key) => (
      <Grid key={`skeleton-${key}`} item xs>
        <Skeleton height={12.25} />
      </Grid>
    ))}
  </Grid>
)

export function DeliveryDirectionVerticals() {
  const {verticals, toggleBannerVisibilityHandler, isBannerVisible} = useDeliveryDirectionVerticals()

  if (verticals && verticals.length > 0) {
    return (
      <>
        <Grid wrap="wrap" container>
          {verticals?.map(vertical => (
            <Grid key={vertical.id} className={classes.item} xs={4} item>
              <VerticalPlate
                disabled={verticals.length === 1}
                name="offerFlow.vertical.name"
                onClick={toggleBannerVisibilityHandler}
                vertical={vertical}
              />
            </Grid>
          ))}
        </Grid>
        <BusinessBannerModal
          description={translations.description}
          imageSrc={translations.imageSrc}
          list={translations.list}
          onClose={toggleBannerVisibilityHandler}
          opened={isBannerVisible}
          title={translations.title}
        />
      </>
    )
  }

  return skeleton
}
